module.exports = __webpack_public_path__ + "img/normal.0c6da9c1.svg";